import React, { useEffect, useState } from "react";
import axios from "axios";

import { ImultipleCards } from "@/components/multipleCards/IMultipleCards";
import {
  canadaIsoCode,
  dnbComLog,
  dnbGetCookie,
  isNotUndefined,
  languagePreferenceCookieName,
  LogSeverity,
  // setCompanyInfoCookie,
  sitePreferenceCookieName,
  // track_event,
  // unitedStatesIsoCode
} from "@/shared/FunctionCore";

const executeSetAnchorsSectionData = () => {
  // TODO
  const setAnchorsSectionData = window["___SET_ANCHORS_SECTION_DATA___"];

  if (setAnchorsSectionData) {
    setAnchorsSectionData();
  }
};

const Cards = (props: ImultipleCards): JSX.Element => {
  const {
    businessCreditReportProductCaUrl,
    // companyInformationForCookie,
    creditReportsEntries,
    suppress_credit_report_product_link_with_text,
  } = props;

  const suppressCreditReportProductLinkWithText = suppress_credit_report_product_link_with_text;

  // "seeAllLinkPath": "\".html"
  // if (typeof seeAllLinkPath !== "string") {
  //   throw new Error("typeof props.seeAllLinkPath is not string");
  // }

  const [locale, setLocale] = useState<string | undefined>();
  const [country, setCountry] = useState<string | undefined>();

  useEffect(() => {
    const countryFromLocalStorage = window.localStorage.getItem("country");

    // TODO
    // Having issues fetching country with Akamai. I chose ip2c for the time being. Need to revisit after redesign launch.
    if (countryFromLocalStorage === null) {
      axios
        .get("https://ip2c.org/self")
        .then((ax) => {
          const [apiStatus, apiCountry] = ax.data.split(";");

          if (apiStatus !== "1") {
            dnbComLog(LogSeverity.ERROR, "Unable to fetch country");
          }

          setCountry(apiCountry === null ? void 0 : apiCountry);

          window.localStorage.setItem("country", apiCountry);

          executeSetAnchorsSectionData();
        })
        .catch((error) => {
          dnbComLog(LogSeverity.ERROR, error);
        });
    } else {
      setCountry(countryFromLocalStorage);

      executeSetAnchorsSectionData();
    }

    const determineLocale = () => {
      const windowLocalStorageLocale = window.localStorage.getItem("locale");

      setLocale(windowLocalStorageLocale === null ? void 0 : windowLocalStorageLocale);
    };

    determineLocale();

    window.addEventListener("storage", determineLocale);
  }, []);

  return (
    <>
      <div className="credit-reports-details pad-lr-0">
        {creditReportsEntries!.map((re, nu) => {
          const detail = re["detail"];
          const linkText = re["linkText"]!;
          const linkUrl = re["linkUrl"];
          const paragraph = re["paragraph"];

          const hideCreditReportsDetail = ((typeof locale === "string" && locale.includes("ca-")) || country === canadaIsoCode) && suppressCreditReportProductLinkWithText.length > 0 && linkText.includes(suppressCreditReportProductLinkWithText);

          const sitePreferenceCookieValue = dnbGetCookie(sitePreferenceCookieName);

          const languagePreferenceCookieValue = dnbGetCookie(languagePreferenceCookieName);

          const href =
            (
              isNotUndefined(sitePreferenceCookieValue)
              && sitePreferenceCookieValue.includes("-ca")
              && isNotUndefined(businessCreditReportProductCaUrl)
            )
              ?
              ((
                typeof languagePreferenceCookieValue === "string"
                && languagePreferenceCookieValue.includes("-ca")
                && languagePreferenceCookieValue.slice(0, 2).length === 2
                && businessCreditReportProductCaUrl.length > 0
              )
                ? businessCreditReportProductCaUrl.replace("{{lang}}", languagePreferenceCookieValue.slice(0, 2))
                : businessCreditReportProductCaUrl)
              : linkUrl;

          return (
            hideCreditReportsDetail
              ? <></>
              : <div
                className="credit-reports-detail"
                key={nu}>
                <div className="detail">
                  {detail}
                </div>

                <p className="paragraph">
                  {paragraph}
                </p>

                <div className="credit-link detail-link">
                  <a
                    href={href}
                  // onClick={() => {
                  //   if (isNotUndefined(companyInformationForCookie)) {
                  //     setCompanyInfoCookie(companyInformationForCookie);
                  //   }

                  //   track_event(`${linkText} clicked`);
                  // }}
                  >
                    {linkText}

                    <span className="chevron-right-arrow-blue" />
                  </a>
                </div>
              </div>
          );
        })}
      </div>
    </>
  );
};

export default Cards;
